import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Ticket } from '../models';

@Injectable()
export class TicketsSharedService {
  private chatsDetailsTicketEventSubject = new BehaviorSubject<Ticket | null>(null);
  chatsDetailsTicketEvent$ = this.chatsDetailsTicketEventSubject.asObservable();

  private chatUpdateSource = new Subject<{ roomId: string; ticketClosed: 'opened' | 'closed' }>();
  chatUpdate$ = this.chatUpdateSource.asObservable();

  triggerEventFromChatDetails(eventData: Ticket | null) {
    this.chatsDetailsTicketEventSubject.next(eventData);
  }

  emitChatUpdate(roomId: string, ticketClosed: 'opened' | 'closed') {
    this.chatUpdateSource.next({ roomId, ticketClosed });
  }
}